export const FETCH_LEX_DETAIL = 'FETCH_LEX_DETAIL';
export const FETCHING_LEX_DETAIL = 'FETCHING_LEX_DETAIL';
export const FETCHING_LEX_DETAIL_SUCCESS = 'FETCHING_LEX_DETAIL_SUCCESS';
export const FETCHING_LEX_DETAIL_ERROR = 'FETCHING_LEX_DETAIL_ERROR';
export const CLEAR_LEX_DETAIL = 'CLEAR_LEX_DETAIL';
export const SET_IS_BLOCK = 'SET_IS_BLOCK';
export const REQUEST_CERT_VOUCHER = 'REQUEST_CERT_VOUCHER';
export const REQUEST_VOUCHER_ERROR = 'REQUEST_VOUCHER_ERROR';
// export const REQUEST_VOUCHER_SUCCESS = 'REQUEST_VOUCHER_SUCCESS';
